import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/utils/betSlip/getAvailableOpportunities';
import { select } from '@swf/core/store';

import type { FormData } from '../types';

const useBetslipHasItemWithoutOdds = (): boolean => {
  const { values } = useFormState<FormData>();
  const singles = useSelector(select.betSlip.singleOpportunities);
  const availableSingles = getAvailableSingleOpportunities(singles);

  return availableSingles.some(
    (single) => !single.winRunnerOdds || values[single.id]?.startingPriceSelected
  );
};

export default useBetslipHasItemWithoutOdds;
